export const FLOW_VERSION = "5.1";

export const LIMITS = {
  MAX_SCREENS: 20,
  MIN_SCREENS: 1,
  MAX_JSON_SIZE_KB: 100,
  SCREEN_ID_MAX_LEN: 30,
  SCREEN_TITLE_MAX_LEN: 80,
  FORM_NAME_MAX_LEN: 30,
  MAX_COMPONENTS_PER_FORM: 50,
  MAX_COMPONENTS_PER_SCREEN: 50,
  TEXT_INPUT_NAME_MAX: 30,
  TEXT_INPUT_LABEL_MAX: 80,
  TEXT_INPUT_DEFAULT_MAX: 200,
  TEXT_INPUT_MAX_LEN: 200,
  DROPDOWN_OPTIONS_MAX: 20,
  RADIO_OPTIONS_MAX: 10,
  CHECKBOX_OPTIONS_MAX: 10,
  OPTION_ID_MAX: 30,
  OPTION_TITLE_MAX: 80,
  DATEPICKER_NAME_MAX: 30,
  DATEPICKER_LABEL_MAX: 80,
  FOOTER_LABEL_MAX: 20,
  TEXT_HEADING_MAX: 120,
  TEXT_SUBHEADING_MAX: 120,
  TEXT_BODY_MAX: 400,
  TEXT_CAPTION_MAX: 200,
  RICH_TEXT_MAX: 1000,
  IMAGE_HEIGHT_MIN: 0,
  IMAGE_HEIGHT_MAX: 400,
};

export const VALID_INPUT_TYPES = ["text", "email", "phone", "number", "password"];

export const RESERVED_FIELD_NAMES = ["screen", "form", "layout", "footer", "action"];

export const SCREEN_ID_REGEX = /^[A-Za-z_]+$/;
export const FIELD_NAME_REGEX = /^[A-Za-z0-9_]+$/;

// Text-like components allowed at layout level (outside Form)
export const LAYOUT_TEXT_TYPES = [
  "TextHeading",
  "TextSubheading",
  "TextBody",
  "TextCaption",
  "RichText",
  "Image",
];

// Input components that MUST be inside a Form
export const INPUT_TYPES = [
  "TextInput",
  "Dropdown",
  "RadioButtonsGroup",
  "CheckboxGroup",
  "DatePicker",
];

// Components available to add inside a Form's children
export const FORM_COMPONENT_TYPES = [
  { value: "TextInput", label: "Text Input" },
  { value: "Dropdown", label: "Dropdown" },
  { value: "RadioButtonsGroup", label: "Radio Buttons" },
  { value: "CheckboxGroup", label: "Checkbox Group" },
  { value: "DatePicker", label: "Date Picker" },
  { value: "TextHeading", label: "Text Heading" },
  { value: "TextSubheading", label: "Text Subheading" },
  { value: "TextBody", label: "Text Body" },
  { value: "TextCaption", label: "Text Caption" },
  { value: "RichText", label: "Rich Text" },
  { value: "Footer", label: "Footer Button" },
];

// Layout-level components (outside Form)
export const LAYOUT_COMPONENT_TYPES = [
  { value: "TextHeading", label: "Heading" },
  { value: "TextSubheading", label: "Subheading" },
  { value: "TextBody", label: "Body Text" },
  { value: "TextCaption", label: "Caption" },
  { value: "RichText", label: "Rich Text" },
  { value: "Image", label: "Image" },
];

export const FLOW_CATEGORIES = [
  { value: "LEAD_GENERATION", label: "Lead Generation" },
  { value: "SIGN_UP", label: "Sign Up" },
  { value: "APPOINTMENT_BOOKING", label: "Appointment Booking" },
  { value: "CONTACT_US", label: "Contact Us" },
  { value: "CUSTOMER_SUPPORT", label: "Customer Support" },
  { value: "SURVEY", label: "Survey" },
  { value: "OTHER", label: "Other" },
];
